<!-- Desktop Screen -->
@if (bigScreenMode) {
  <ion-grid class="ion-no-padding">
    <ion-row class="sis-ion-row vertical-align-content">
      <ion-col>
        <ion-icon
          [name]="item.options.iconName"
          class="sis-statusicon"
          [ngClass]="item.status === null ? 'sis-no-status' : item.options.colorClassName"
          matTooltip="{{
            (item.status !== null ? item.options.tooltipTranslationString : 'webreport.term.noStatus') | translate
          }}"
        ></ion-icon>
        <img class="sis-icon" [src]="icon" [matTooltip]="item.typeDescription" />
        @if (config?.showLabel && longestLabelLength !== 0) {
          <div class="sis-label" [style.maxWidth]="showingLabelLength" [style.minWidth]="showingLabelLength">
            {{ item.label }}
          </div>
        }
        <div class="sis-name sis-truncate">
          {{ name }}
        </div>
        @if (item.info) {
          <div class="sis-desktop-info-icon-container" [matTooltip]="item.info">
            <ion-icon class="sis-info-icon" name="information-circle-outline"></ion-icon>
          </div>
        }
        @if (config?.showLength && item.lengthMeter !== 0 && (item.assetCategory === 2 || item.assetCategory === 3)) {
          <div class="sis-length">
            {{ item.lengthMeter | metersToKilometers }}
          </div>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
}

<!-- Mobile Screen -->
@if (!bigScreenMode) {
  <ion-grid class="ion-no-padding">
    <ion-row
      class="sis-ion-row-small vertical-align-content"
      [ngClass]="mobileStyleTenant ? 'sis-ion-row-small-tenant-style' : 'sis-ion-row-small-sisag-style'"
    >
      <ion-col>
        <ion-icon
          [name]="item.options.iconName"
          class="sis-statusicon-small"
          [ngClass]="item.status === null ? 'sis-no-status' : item.options.colorClassName"
          matTooltip="{{
            (item.status !== null ? item.options.tooltipTranslationString : 'webreport.term.noStatus') | translate
          }}"
        ></ion-icon>
        <img class="sis-icon-small" [class.sis-icon-invert]="invert" [src]="icon" />
        @if (config?.showLabel && longestLabelLength !== 0) {
          <div class="sis-label" [style.maxWidth]="showingLabelLength" [style.minWidth]="showingLabelLength">
            {{ item.label }}
          </div>
        }
        <div class="sis-name sis-truncate">
          {{ item.name }}
        </div>
        @if (item.info) {
          <ion-icon
            class="sis-info-icon-small"
            [class.sis-icon-invert]="invert"
            name="information-circle-outline"
            (click)="openInfo()"
          ></ion-icon>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
}
